// 客户账号管理-菜单 L3
const config = {
    'contractGroupManage': { // 客户账号管理-页面 L4
        'bigData-page-detailPage-priceDetail': '合同管理,合同组管理-合同组详情页,价格表子页签,' // 合同组管理-合同组详情页-价格表子页签 L5
    }
};

export default config;
